<basket-view-totals class="block"
                    [allowEmptySubtotal]="true"></basket-view-totals>

@if (isSamples) {
<newsletter-checkboxes class="block"
                       [email]="email"
                       source="checkout"
                       [checkoutData]="checkoutFormComponent.data"
                       [beforeSubmitSubject]="checkoutFormComponent.beforeSubmitSubject"
                       [variant]="'samples'"></newsletter-checkboxes>
}

@if (['adyen_google_pay','adyen_apple_pay','cybersource_applepay', 'cybersource_googlepay'].indexOf(paymentMethodCode)
=== -1) {
<action (click)="submit()"
        [status]="status"
        [ngClass]="{'b-a-0' : paymentMethodCode === 'paypal_express', 'busy' : checkoutFormComponent.savePaymentMethodStatus.busy}"
        [ngStyle]="{'backgroundColor' : paymentMethodCode === 'paypal_express' ? '#ffc439' : undefined}"
        class="button w-12 m-t">
    @if (paymentMethodCode === 'paypal_express') {
    <img style="height: 24px;margin-top: 3px;"
         [image]="'/assets/images/logo-paypal.svg'" />
    } @else {
    {{ (isSamples ? 'Order Samples' : paymentMethodCode
    === 'vfinance' ? 'Continue to v12' : 'Place order') |
    translate }}
    }

</action>
}

@if (isPaymentMethodAvailable('adyen_google_pay')) {
<adyen-google-pay [ngClass]="{'visually-hidden': paymentMethodCode !== 'adyen_google_pay'}"
                  class="w-12 m-t"></adyen-google-pay>
}
@if (isPaymentMethodAvailable('cybersource_googlepay')) {
<barclaycard-google-pay [ngClass]="{'visually-hidden': paymentMethodCode !== 'cybersource_googlepay'}"
                        class="w-12 m-t"></barclaycard-google-pay>
}

<ng-container *ifApplePayAvailable>
    @if (isPaymentMethodAvailable('adyen_apple_pay')) {
    <adyen-apple-pay [ngClass]="{'visually-hidden': paymentMethodCode !== 'adyen_apple_pay'}"
                     class="w-12 m-t"></adyen-apple-pay>
    }
    @if (isPaymentMethodAvailable('cybersource_applepay') && paymentMethodCode === 'cybersource_applepay') {
    <barclaycard-apple-pay class="w-12 m-t"></barclaycard-apple-pay>
    }
</ng-container>


<result [status]="status"
        [success]="('Data saved... redirecting...'| translate)"></result>
@if (paymentMethodCode === 'paypal_express') {
<paypal-pay-in-three-message class="block m-t-2"
                             [amount]="customer.basket.totals?.grand_total.toFixed(2)"></paypal-pay-in-three-message>
}

<p class="p2 col-12 m-t center">
    {{'By placing your order you agree to our' | translate}}&nbsp;<a routerLink="/terms-and-conditions"
       target="_blank"
       class="underline"
       translate>Terms and Conditions</a>.
</p>
